module.exports = __webpack_public_path__ + "img/write.940b8816.png";